import React, { forwardRef } from 'react'

type EntryItemProps = {
  title: string | React.ReactNode
  description: string | React.ReactNode
  isSelected: boolean
  onClick?: () => void
  onMouseEnter: () => void
}

export const EntryItem = forwardRef<HTMLDivElement, EntryItemProps>(
  ({ title, description, isSelected, onClick, onMouseEnter }, ref) => {
    const backgroundColor = isSelected ? '#f3f4f6' : 'transparent'

    const borderColor = isSelected ? '#d1d5db' : 'transparent'

    return (
      <div
        ref={ref}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        style={{
          padding: '8px 16px',
          marginBottom: '2px',
          borderRadius: '6px',
          cursor: onClick ? 'pointer' : 'default',
          transition: 'all 0.15s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          backgroundColor,
          border: `1px solid ${borderColor}`,
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '14px',
            color: '#111827',
            lineHeight: 1.4,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: '12px',
            color: '#6b7280',
            lineHeight: 1.4,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {description}
        </div>
      </div>
    )
  }
)

EntryItem.displayName = 'EntryItem'
